var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container",attrs:{"name":"fade"}},[_c('router-view'),_c('WebSocket',{ref:"childWs",attrs:{"merchantId":_vm.realMerchantId,"signReq":_vm.signString}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }